var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LLModalConditional"},[(_vm.localOpened)?_c('LLModal',{attrs:{"name":_vm.name},on:{"closed":_vm.hideModal}},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }